module.exports = __webpack_public_path__ + "static/media/rejected_empty_mobile.5b556371.svg";